import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SystemAlert } from '../../../../services/application-config.service';

@Component({
    selector: 'app-edit-system-alert',
    templateUrl: './edit-system-alert.component.html',
    styleUrls: ['./edit-system-alert.component.scss'],
    standalone: false
})
export class EditSystemAlertComponent {
    @Input() showEditModal: boolean = false;
  @Input() savingAlert: boolean = false;
  @Input() alert: SystemAlert;
  @Output() onUpdate = new EventEmitter<SystemAlert>();
    @Output() onCancel = new EventEmitter<void>();

    public alertForm: FormGroup;
    public startDate: string = '';
    public endDate: string = '';

    constructor(private fb: FormBuilder) { }

    ngOnInit() {

        this.alertForm = this.fb.group(
            {
                title: [this.alert.title],
                message:[this.alert.message],
                startDate: [this.formatDateTime(this.alert.startDate), Validators.required],
                endDate: [this.formatDateTime(this.alert.endDate), Validators.required],
            },
            { validators: this.dateRangeValidator }
        );

        //this.startDate = this.formatDateTime(this.alert.startDate);
        //this.endDate = this.formatDateTime(this.alert.endDate);

      
    }

    // Ensure dates are in the correct format for datetime-local
    private formatDateTime(date: string | Date): string {
        if (!date) return '';
        const d = new Date(date);
        const offset = d.getTimezoneOffset(); 
        d.setMinutes(d.getMinutes() - offset); 
        return d.toISOString().slice(0, 16);
    }

    private dateRangeValidator(group: AbstractControl): { [key: string]: boolean } | null {
        const startDate = group.get('startDate').value;
        const endDate = group.get('endDate').value;

        if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
            return { dateRangeInvalid: true }; // Validation error
        }
        return null;
    }

    public updateAlert() {
        if (this.alertForm.valid) {
            this.alert.startDate = new Date(this.alertForm.value.startDate);
            this.alert.endDate = new Date(this.alertForm.value.endDate);
            this.onUpdate.emit(this.alert);
        }
  }

    public cancel() {
    this.onCancel.emit();
  }
}